import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import { installRecorder } from './lib/feedback/recorder';
import './fonts.css';
import './styles.css';

// Feedback recorder first (imports above only define modules; nothing has rendered yet), so
// errors and failed requests from the very first render are captured.
installRecorder();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
